/**
 * so_c2030.js - 개인신용정보에 관한 동의서 페이지 전용 스크립트
 */

// 이메일 도메인 설정
function setEmailDomain(domain) {
  if (domain) {
    document.getElementsByName('email2')[0].value = domain;
    document.getElementsByName('email2')[0].readOnly = true;
  } else {
    document.getElementsByName('email2')[0].value = '';
    document.getElementsByName('email2')[0].readOnly = false;
  }
}

// 휴대전화 인증
function verifyPhone() {
  const phone1 = document.getElementsByName('phone1')[0].value;
  const phone2 = document.getElementsByName('phone2')[0].value;
  const phone3 = document.getElementsByName('phone3')[0].value;
  const telecom = document.querySelector('input[name="telecom"]:checked');
  
  if (!phone1 || !phone2 || !phone3) {
    alert('휴대전화번호를 모두 입력해주세요.');
    return;
  }
  
  if (!telecom) {
    alert('통신사를 선택해주세요.');
    return;
  }
  
  alert('휴대전화 인증 기능은 실제 서비스에서 구현됩니다.');
}

// 약관 내용 표시
function showAgreement(num) {
  const modal = document.getElementById('agreementModal');
  const title = document.getElementById('agreementTitle');
  const content = document.getElementById('agreementContent');
  
  const agreements = {
    1: {
      title: '개인(신용)정보 조회 동의서',
      content: `
        <p class="modal-notice">※ 필수 동의 사항에 대한 동의는 계약의 체결 및 이행을 위하여 필수적이므로, 아래 사항에 동의하셔야만 대부 거래 관계의 설정 또는 유지가 가능합니다.</p>
        
        <p class="modal-company">빌리언대부 주식회사 귀중</p>
        
        <p class="modal-intro">본인은 "신용정보의 이용 및 보호에 관한 법률" 제15조, 제32조 및 "개인정보 보호법" 제15조, 제17조, 제24조, 제24조의2에 따라 빌리언대부 주식회사이(가) 본인이 신청한 대부 거래에 관하여 아래와 같은 내용으로 신용조회 회사, 신용정보집중기관, 공공기관이나 통신회사로부터 본인의 신용정보를 조회하는 것에 대하여 동의합니다.</p>
        
        <h4 class="modal-section-title">1. 조회 목적</h4>
        <p class="modal-content-text">◦ 계약 등 대부 거래의 체결･유지･이행･관리</p>
        
        <h4 class="modal-section-title">2. 조회할 신용정보</h4>
        <p class="modal-content-text">◦ 개인식별정보, 신용거래 정보, 신용 능력 정보, 신용도 판단 정보, 공공기관 정보</p>
        <ul class="modal-list" style="list-style-type: none; padding-left: 0;">
          <li class="modal-list-item">◦ 일반 개인정보 : 성명, 주소, 직장 정보, 전화번호, 입금 계좌, 연계 정보(CI) 등</li>
          <li class="modal-list-item">◦ 신용거래 정보 : 대출, 보증, 담보제공, 현금서비스, 카드론, 신용카드, 자사 대출 신청 정보(신청 번호, 신청 일자, 신청 구분, 신청 채널, 대출상품, 신청 금액 등) 및 증권 계좌번호 등</li>
          <li class="modal-list-item">◦ 신용도 판단 정보 : 신용평점, 연체, 부도, 대위변제, 기타 신용 질서 문란 행위 관련 금액 등</li>
          <li class="modal-list-item">◦ 신용 능력 정보 : 개인의 재산, 채무, 소득의 총액, 납세 실적 등</li>
          <li class="modal-list-item">◦ 공공정보 등 : 법원의 재판·결정 정보, 체납정보, 사회보험 및 공공요금 관련 정보 등</li>
        </ul>
        
        <h4 class="modal-section-title">3. 조회처</h4>
        <p class="modal-content-text">◦ 신용조회회사 (코리아크레딧뷰로㈜ 등), 신용정보집중기관, 공공기관 및 통신회사</p>
        
        <h4 class="modal-section-title">4. 조회동의 효력 기간</h4>
        <p class="modal-content-text">◦ 위 동의는 당해 거래종료일 (채권・채무관계가 해소된 시점) 까지 효력이 유지되나, 본인이 신청한 대부거래가 귀사에 의해 거절된 경우에는 그 시점까지 유효합니다.</p>
        
        <p class="modal-footer-note">▪ 본인은 귀사가 위와 같이 본인의 개인(신용)정보를 조회하는 것에 동의합니다.</p>
        <p class="modal-footer-note">▪ 본인은 귀사가 위 목적으로 다음과 같은 본인의 고유식별정보를 처리하는 것에 동의합니다.</p>
        <p class="modal-content-text" style="padding-left: 20px;">※ 고유식별정보 : 주민등록번호(금융위원회에 등록한 대부업자인 경우), 운전면허번호, 여권번호, 외국인등록번호</p>
      `
    },
    2: {
      title: '개인(신용)정보 제공 동의서',
      content: `
        <p class="modal-notice">※필수 동의 사항에 대한 동의는 계약의 체결 및 이행을 위하여 필수적이므로, 아래 사항에 동의하셔야만 대부 거래 관계의 설정 또는 유지할 수 있습니다.</p>
        
        <p class="modal-company">빌리언대부 주식회사 귀중</p>
        
        <p class="modal-intro">본인은 "개인정보 보호법" 제17조, 제22조, 제24조, 제24조의2, "신용정보의 이용 및 보호에 관한 법률" 제32조, 제33조, 제34조, "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 제24조의2, 제25조, 제26조의2에 따라 빌리언대부 주식회사이(가) 본인이 신청한 대부 거래에 관하여 본인의 개인(신용)정보를 아래와 같이 제3자에게 제공하는 것에 대하여 동의합니다.</p>
        
        <h4 class="modal-section-title">1. 제공 목적</h4>
        <p class="modal-content-text">◦ 본인확인 및 신용도 평가 등 신용조회업무, 신용정보의 집중 관리 및 활용 등 신용정보집중기관의 업무, 계약 등 대부 거래의 체결･유지･이행･관리(연체 관리 및 채권 관리 포함)</p>
        
        <h4 class="modal-section-title">2. 제공 정보 내역</h4>
        <p class="modal-content-text">◦ 개인식별정보, 신용거래 정보, 신용 능력 정보, 신용도 판단 정보</p>
        
        <h4 class="modal-section-title">3. 정보 제공처</h4>
        <ul class="modal-list" style="list-style-type: none; padding-left: 0;">
          <li class="modal-list-item">◦ 신용조회회사 [KCB 코리아크레딧뷰로(주), (주)나이스평가정보]</li>
          <li class="modal-list-item">◦ 신용정보집중기관 [한국신용정보원]</li>
          <li class="modal-list-item">◦ 수탁업체 [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]</li>
        </ul>
        <p class="modal-content-text">※ 위 내용이 변동하는 경우 회사 홈페이지에 게시 등을 통해 그 내용을 공시합니다.</p>
        
        <h4 class="modal-section-title">4. 정보 보유기간</h4>
        <p class="modal-content-text">◦ 신용조회회사 및 신용정보집중기관에 제공한 개인(신용)정보는 신용정보의 이용 및 보호에 관한 법률 및 관련 규약에 근거한 기간까지, 수탁업체에 제공한 개인(신용)정보는 거래종료일(채권・채무관계가 해소된 시점) 이내에서 수탁계약 종료시까지 보유ㆍ이용됩니다. 다만, 마케팅 목적의 정보는 제공 동의일로부터 2년 이내로 이용이 제한됩니다.</p>
        
        <p class="modal-footer-note">▪ 본인은 위와 같이 본인의 개인(신용)정보를 제3자에게 제공하는 것에 동의합니다.</p>
        <p class="modal-footer-note">▪ 본인은 귀사가 위 목적으로 다음과 같은 본인의 고유식별정보를 처리하는 것에 동의합니다.</p>
        <p class="modal-content-text" style="padding-left: 20px;">※ 고유식별정보 : 주민등록번호(금융위원회에 등록한 대부업자인 경우), 운전면허번호, 여권번호, 외국인등록번호</p>
      `
    },
    3: {
      title: '개인(신용)정보 수집·이용 동의서',
      content: `
        <p class="modal-notice">※ 필수 동의사항에 대한 동의는 계약의 체결 및 이행을 위하여 필수적이므로, 아래 사항에 동의하셔야만 대부 거래 관계의 설정 또는 유지할 수 있습니다.</p>
        
        <p class="modal-company">빌리언대부 주식회사 귀중</p>
        
        <p class="modal-intro">※ 본인은 "개인정보 보호법" 제15조, 제22조, 제24조, 24조의 2, "신용정보의 이용 및 보호에 관한 법률" 제15조, 제32조, 제33조, 제34조, "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 제22조, 제26조의2에 따라 빌리언대부 주식회사이(가) 본인이 신청한 대부 거래와 관련하여 본인의 개인(신용)정보를 아래와 같이 수집‧이용하는 것에 대하여 동의합니다.</p>
        
        <h4 class="modal-section-title">1. 수집‧이용 목적</h4>
        <ul class="modal-list" style="list-style-type: none; padding-left: 0;">
          <li>◦ 본인확인, 신용조회, 대금결제 등 대부계약의 체결･유지･이행･관리</li>
          <li>◦ 신청 금융상품 서비스 제공</li>
          <li>◦ 법령상 의무이행, 분쟁 처리, 민원 해결, 금융사고 조사 등</li>
        </ul>
        
        <h4 class="modal-section-title">2. 수집‧이용할 개인(신용)정보의 내용</h4>
        <ul class="modal-list" style="list-style-type: none; padding-left: 0;">
          <li>◦ 개인식별정보(성명, 고유 식별정보, 자택(직장) 주소, 연락처, 직장명 및 사업자번호, 입금 계좌)</li>
          <li>◦ 신용거래 정보(본 거래 이전 및 이후의 대부, 보증, 담보제공 등 거래 내용을 판단할 수 있는 정보)</li>
          <li>◦ 신용 능력 정보(대부 금액이 300만 원(거래상대방이 29세 이하이거나 70세 이상인 경우 100만 원)을 초과하면 소득･재산, 채무의 총액 등을 의무적으로 파악)</li>
          <li>◦ 신용도 판단 정보(신용등급･신용평점, 연체, 부도, 대위변제, 기타 신용 질서 문란 행위 관련 금액 등)</li>
          <li>◦ 공공기관 정보(개인회생, 파산, 면책, 채무 불이행자 등재 등 법원의 재판･결정 정보, 체납 정보, 경매 관련 정보, 사회보험ㆍ공공요금 관련 정보, 행정처분에 관한 정보 등)</li>
        </ul>
        <p class="modal-content-text">► 본 동의 이전에 발생한 상기 개인(신용)정보 포함</p>
        
        <h4 class="modal-section-title">3. 개인(신용)정보 보유･이용 기간</h4>
        <p class="modal-content-text">◦ 수집ㆍ이용 동의 일로부터 본인이 신청한 대부 거래가 귀사로 거절된 시점 또는 거래 종료(채권･채무 관계가 해소된 시점) 후 5년까지 금융사고 조사, 분쟁 해결, 민원 처리 및 법령상 의무이행을 위해서만 보유ㆍ이용됩니다.</p>
        
        <p class="modal-footer-note">▪ 본인은 귀사가 상기와 같이 본인의 개인(신용)정보를 수집ㆍ이용하는 것에 동의합니다.</p>
        <p class="modal-footer-note">▪ 본인은 귀사가 상기 목적으로 다음과 같은 본인의 고유 식별정보를 처리하는 것에 동의합니다.</p>
        <p class="modal-content-text" style="padding-left: 20px;">※ 고유식별정보 : 주민등록번호(금융위원회에 등록한 대부업자인 경우), 운전면허번호, 여권번호, 외국인등록번호</p>
      `
    },
    4: {
      title: '고유 식별정보 처리 동의서(필수)',
      content: `
        <p class="modal-notice">※필수 동의 사항에 대한 동의는 계약의 체결 및 이행을 위하여 필수적이므로, 아래 사항에 동의하셔야만 대부 거래 관계의 설정 또는 유지할 수 있습니다.</p>
        
        <p class="modal-company">빌리언대부 주식회사 귀중</p>
        
        <p class="modal-intro">※ 빌리언대부 주식회사이(가) 개인정보 보호법 제24조에 따라 본인의 개인(신용)정보를 수집·이용, 제공, 조회 시 동의한 목적에 의거 본인의 고유 식별정보를 처리하는 것에 동의합니다.</p>
        
        <h4 class="modal-section-title">▪고유 식별정보</h4>
        <p class="modal-content-text">※ 고유식별정보 : 주민등록번호(금융위원회에 등록한 대부업자인 경우), 운전면허번호, 여권번호, 외국인등록번호</p>
      `
    },
    5: {
      title: '개인(신용) 정보제공동의서(선택)',
      content: `
        <p class="modal-notice">※귀하는 개인(신용)정보의 선택적인 수집･이용, 제공에 대한 동의를 거부할 수 있습니다. 다만, 동의하지 않을 경우 관련 편의 제공(무이자 또는 이자율 인하 이벤트, 한도 증액, 사은품 제공 등)에 제한이 있을 수 있지만 그 밖의 대부 거래와 관련된 불이익은 없습니다. 또한, 동의하셨더라도 당사 홈페이지 또는 고객센터 등을 통해 철회할 수 있습니다.</p>
        
        <p class="modal-company">빌리언대부 주식회사 귀중</p>
        
        <p class="modal-intro">※ 빌리언대부 주식회사과(와)의 (금융) 거래와 관련하여 귀사가 본인으로부터 취득한 개인(신용)정보는 「개인정보 보호법」 제17조 및 제22조, 제24조, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제24조의2, 제26조의2, 「신용정보의 이용 및 보호에 관한 법률」 제32조 및 제33조 및 제34조에 따라 제삼자에게 제공할 경우 본인의 사전동의를 얻어야 하는 정보입니다. 이에 본인은 귀사가 본인의 개인(신용)정보를 아래와 같이 제삼자에게 제공하는 것에 대해 동의합니다.</p>
        
        <h4 class="modal-section-title">개인(신용)정보의 선택적인 수집․이용에 관한 사항</h4>
        
        <h4 class="modal-section-title">▪수집·이용 목적</h4>
        <ul class="modal-list" style="list-style-type: none; padding-left: 0;">
          <li>◦ 상품·서비스 안내 및 이용 권유, 판촉 활동</li>
          <li>◦ 상품·서비스 연구개발 및 고객 통계 및 분석</li>
          <li>◦ 고객상담</li>
        </ul>
        
        <h4 class="modal-section-title">▪보유 및 이용 기간</h4>
        <p class="modal-content-text">(금융) 거래 종료일로부터 3개월 또는 동의 철회 중 먼저 도래하는 시점까지 보유 이용됩니다.</p>
        <p class="modal-content-text">＊(금융) 거래 종료일이란 "당사와 거래 중인 계약 및 서비스가 종료된 날"을 뜻합니다.</p>
        
        <h4 class="modal-section-title">▪거부 권리 및 불이익</h4>
        <p class="modal-content-text">귀하는 아래 개인(신용)정보 수집·이용에 관한 동의를 거부하실 수 있습니다. 다만, 동의하지 않으시는 경우 "상품·서비스 안내 등"의 혜택을 받지 못할 수 있습니다.</p>
        
        <h4 class="modal-section-title">▪수집·이용 항목</h4>
        <ul class="modal-list" style="list-style-type: none; padding-left: 0;">
          <li>◦ <strong>개인(신용)정보</strong></li>
          <li style="padding-left: 20px;">○ 일반 개인정보: 성명, 생년월일, 성별, 연락처, 직장 정보, 주소</li>
          <li style="padding-left: 20px;">○ 신용거래 정보: 상품 종류, 거래일시, 대출금액, 거래명세 정보, 거래조건(이자율, 만기, 담보 여부)</li>
          <li style="padding-left: 20px;">○ 공공정보: 신용 점수 데이터</li>
          <li style="padding-left: 20px;">○ 신용 능력 정보: 주거 정보</li>
        </ul>
        
        <p class="modal-footer-note">◆본인은 귀사가 상기 수집․이용 목적으로 다음과 같은 본인의 고유 식별정보를 수집․이용하는 것에 동의합니다.</p>
        <p class="modal-content-text" style="padding-left: 20px;">※ 고유식별정보 : 주민등록번호(금융위원회에 등록한 대부업자인 경우), 운전면허번호, 여권번호, 외국인등록번호</p>
      `
    },
    6: {
      title: '개인(신용)정보 수집·이용 동의서(선택)',
      content: `
        <p class="modal-notice">※ 귀하는 개인(신용)정보의 선택적인 수집·이용에 대한 동의를 거부할 수 있습니다. 다만, 동의하지 않을 경우 관련 편의 제공에 제한이 있을 수 있지만 그 밖의 대부 거래와 관련된 불이익은 없습니다. 또한 동의하셨더라도 당사 고객센터 등을 통해 철회할 수 있습니다.</p>
        
        <p class="modal-company">빌리언대부 주식회사 귀중</p>
        
        <p class="modal-intro">※ 빌리언대부 주식회사이(가) (금융) 거래와 관련하여 귀사가 본인의 개인(신용)정보를 수집․이용하고자 하는 경우에는 "개인정보 보호법" 제15조 및 제22조, 제24조, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제22조, 제24조의2, 제26조의2, "신용정보의 이용 및 보호에 관한 법률" 제33조 및 제34조에 따라 동의를 얻어야 합니다. 이에 본인은 귀사가 아래의 내용과 같이 본인의 개인(신용)정보를 수집․이용하는데 동의합니다.</p>
        
        <h4 class="modal-section-title">▪수집·이용 목적</h4>
        <ul class="modal-list" style="list-style-type: none; padding-left: 0;">
          <li>◦ 상품·서비스 안내 및 이용 권유, 판촉 활동</li>
          <li>◦ 상품·서비스 연구개발 및 고객 통계 및 분석</li>
          <li>◦ 고객상담</li>
        </ul>
        
        <h4 class="modal-section-title">▪보유 및 이용 기간</h4>
        <p class="modal-content-text">(금융) 거래 종료일로부터 3개월 또는 동의 철회 중 먼저 도래하는 시점까지 보유 이용됩니다.</p>
        <p class="modal-content-text">＊(금융) 거래 종료일이란 "당사와 거래 중인 계약 및 서비스가 종료된 날"을 뜻합니다.</p>
        
        <h4 class="modal-section-title">▪거부 권리 및 불이익</h4>
        <p class="modal-content-text">귀하는 아래 개인(신용)정보 수집·이용에 관한 동의를 거부하실 수 있습니다. 다만, 동의하지 않으시는 경우 "상품·서비스 안내 등"의 혜택을 받지 못할 수 있습니다.</p>
        
        <h4 class="modal-section-title">▪수집·이용 항목</h4>
        <p class="modal-content-text">신용 능력 정보, 주거 정보</p>
      `
    },
    7: {
      title: '대부거래 표준약관',
      content: `
        <h3>제1장 총칙</h3>
        <h4>제1조 (목적)</h4>
        <p>이 약관은 대부업자와 대부업 이용자 간의 대부거래에 관한 기본적인 사항을 정함으로써 상호간의 이익을 보호하고 대부거래의 건전한 발전을 도모함을 목적으로 합니다.</p>
        
        <h4>제2조 (용어의 정의)</h4>
        <p>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
        <ul>
          <li>1. "대부업자"라 함은 「대부업 등의 등록 및 금융이용자 보호에 관한 법률」에 의해 등록한 자를 말합니다.</li>
          <li>2. "이용자"라 함은 대부업자로부터 금전을 대부받은 자를 말합니다.</li>
          <li>3. "대부거래"라 함은 대부업자가 이용자에게 금전을 대부하고 이용자가 원금과 이자를 상환하는 거래를 말합니다.</li>
        </ul>
        
        <h3>제2장 대부계약의 체결</h3>
        <h4>제3조 (대부계약의 체결)</h4>
        <p>대부업자와 이용자는 대부거래를 함에 있어 상호 대등한 입장에서 공정하게 계약을 체결하여야 합니다.</p>
        
        <h4>제4조 (계약서류의 교부)</h4>
        <p>대부업자는 대부계약 체결시 이용자에게 다음의 사항이 기재된 계약서류를 교부하여야 합니다.</p>
        <ul>
          <li>1. 대부금액</li>
          <li>2. 대부이자율(연 이자율)</li>
          <li>3. 변제기간 및 방법</li>
          <li>4. 지연손해금률</li>
          <li>5. 담보에 관한 사항</li>
        </ul>
      `
    },
    8: {
      title: '(근)질권설정 계약서',
      content: `
        <h3>(근)질권설정 계약서</h3>
        <p>질권설정자(이하 "갑"이라 합니다)와 질권자(이하 "을"이라 합니다)는 다음과 같이 (근)질권설정계약을 체결합니다.</p>
        
        <h4>제1조 (피담보채무)</h4>
        <p>갑은 을에 대한 다음의 채무를 담보하기 위하여 을에게 질권을 설정합니다.</p>
        <ul>
          <li>1. 대부원금 및 이자</li>
          <li>2. 지연손해금</li>
          <li>3. 채권회수에 필요한 비용</li>
        </ul>
        
        <h4>제2조 (질권의 목적물)</h4>
        <p>질권의 목적물은 다음과 같습니다.</p>
        <ul>
          <li>1. 증권의 종류 및 수량</li>
          <li>2. 증권번호</li>
          <li>3. 기타 질권설정에 필요한 사항</li>
        </ul>
        
        <h4>제3조 (질권의 효력)</h4>
        <p>갑이 피담보채무를 이행하지 아니하는 경우 을은 질권의 목적물로부터 우선변제를 받을 수 있습니다.</p>
        
        <h4>제4조 (질권의 실행)</h4>
        <p>을은 갑이 채무를 이행하지 아니하는 경우 법률이 정하는 바에 따라 질권을 실행할 수 있습니다.</p>
      `
    },
    9: {
      title: '(근)질권설정 승낙 의뢰서',
      content: `
        <h3>(근)질권설정 승낙 의뢰서</h3>
        <p>본인은 빌리언대부 주식회사과의 대부거래와 관련하여 다음과 같이 (근)질권설정 승낙을 의뢰합니다.</p>
        
        <h4>1. 의뢰인 정보</h4>
        <ul>
          <li>성명:</li>
          <li>주민등록번호:</li>
          <li>주소:</li>
        </ul>
        
        <h4>2. 질권설정 내용</h4>
        <ul>
          <li>증권 종류:</li>
          <li>증권 수량:</li>
          <li>증권 번호:</li>
        </ul>
        
        <h4>3. 승낙 사항</h4>
        <p>본인은 위 증권에 대하여 빌리언대부 주식회사을 질권자로 하는 (근)질권설정에 동의하며, 증권회사에 그 승낙을 의뢰합니다.</p>
        
        <h4>4. 유의사항</h4>
        <ul>
          <li>질권설정 후에는 질권자의 동의 없이 증권을 처분할 수 없습니다.</li>
          <li>채무 불이행시 질권자는 질권을 실행할 수 있습니다.</li>
        </ul>
      `
    },
    10: {
      title: '임의처분 및 금융거래정보제공 동의',
      content: `
        <h3>임의처분 및 금융거래정보제공 동의서</h3>
        
        <h4>제1조 (임의처분 동의)</h4>
        <p>본인은 대부계약에 따른 채무를 이행하지 아니하는 경우 대부업자가 담보물을 임의로 처분할 수 있음에 동의합니다.</p>
        
        <h4>제2조 (금융거래정보 제공 동의)</h4>
        <p>본인은 다음의 금융거래정보를 대부업자에게 제공하는 것에 동의합니다.</p>
        <ul>
          <li>1. 계좌번호 및 잔액 정보</li>
          <li>2. 거래내역</li>
          <li>3. 신용정보</li>
          <li>4. 기타 대부거래에 필요한 정보</li>
        </ul>
        
        <h4>제3조 (정보의 이용 목적)</h4>
        <p>제공된 정보는 다음의 목적으로만 이용됩니다.</p>
        <ul>
          <li>1. 대부계약의 체결 및 이행</li>
          <li>2. 채권관리 및 추심</li>
          <li>3. 법령상 의무이행</li>
        </ul>
        
        <h4>제4조 (정보 보호)</h4>
        <p>대부업자는 제공받은 정보를 관련 법령에 따라 안전하게 관리하며, 목적 외의 용도로 사용하거나 제3자에게 제공하지 않습니다.</p>
      `
    },
    11: {
      title: '자동계좌이체약관',
      content: `
        <h3>자동계좌이체 약관</h3>
        
        <h4>제1조 (목적)</h4>
        <p>이 약관은 이용자가 대부원리금을 자동계좌이체 방식으로 상환하는 경우에 적용됩니다.</p>
        
        <h4>제2조 (이체일)</h4>
        <p>자동이체는 매월 약정일에 실행됩니다. 약정일이 휴일인 경우 다음 영업일에 이체됩니다.</p>
        
        <h4>제3조 (이체 금액)</h4>
        <p>이체 금액은 대부계약서에 명시된 월 상환액입니다.</p>
        
        <h4>제4조 (잔액 부족시 처리)</h4>
        <ul>
          <li>1. 이체일 당일 잔액이 부족한 경우 이체가 실행되지 않습니다.</li>
          <li>2. 이체 실패시 지연손해금이 부과될 수 있습니다.</li>
          <li>3. 이용자는 이체일 전까지 충분한 잔액을 유지해야 합니다.</li>
        </ul>
        
        <h4>제5조 (자동이체 해지)</h4>
        <p>자동이체를 해지하고자 하는 경우 최소 3영업일 전까지 대부업자에게 통보해야 합니다.</p>
        
        <h4>제6조 (계좌 변경)</h4>
        <p>이체 계좌를 변경하고자 하는 경우 변경 신청서를 제출해야 합니다.</p>
      `
    },
    12: {
      title: '전자금융거래 표준약관',
      content: `
        <h3>전자금융거래 표준약관</h3>
        
        <h4>제1조 (목적)</h4>
        <p>이 약관은 전자금융거래법에 의거하여 대부업자와 이용자 간의 전자금융거래에 관한 기본적인 사항을 정함을 목적으로 합니다.</p>
        
        <h4>제2조 (용어의 정의)</h4>
        <ul>
          <li>1. "전자금융거래"라 함은 인터넷 등 전자적 장치를 통하여 이루어지는 거래를 말합니다.</li>
          <li>2. "접근매체"라 함은 전자금융거래에 있어서 거래지시를 하거나 이용자 및 거래내용의 진실성과 정확성을 확보하기 위하여 사용되는 수단 또는 정보를 말합니다.</li>
          <li>3. "전자지급수단"이라 함은 전자자금이체, 직불전자지급수단, 선불전자지급수단, 전자화폐, 신용카드 및 전자채권 등을 말합니다.</li>
        </ul>
        
        <h4>제3조 (접근매체의 선정과 관리)</h4>
        <ul>
          <li>1. 대부업자는 이용자의 신원, 권한 및 거래지시의 내용 등을 확인하기 위하여 접근매체를 선정합니다.</li>
          <li>2. 이용자는 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공할 수 없습니다.</li>
          <li>3. 이용자는 접근매체의 도용이나 위조 또는 변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.</li>
        </ul>
        
        <h4>제4조 (거래내용의 확인)</h4>
        <p>대부업자는 이용자가 전자금융거래의 내용을 확인할 수 있도록 다음의 사항이 포함된 거래내용을 제공합니다.</p>
        <ul>
          <li>1. 거래일시</li>
          <li>2. 전자적 장치의 종류 및 전자금융거래의 종류</li>
          <li>3. 거래금액</li>
          <li>4. 거래상대방</li>
        </ul>
        
        <h4>제5조 (오류의 정정 등)</h4>
        <p>이용자는 전자금융거래에 오류가 있음을 안 때에는 즉시 대부업자에게 그 정정을 요구할 수 있습니다.</p>
        
        <h4>제6조 (책임의 제한)</h4>
        <ul>
          <li>1. 대부업자는 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 손해가 발생한 경우 그 손해를 배상할 책임을 집니다.</li>
          <li>2. 다만, 이용자가 접근매체를 제3자에게 대여하거나 그 사용을 위임한 경우 또는 양도나 담보의 목적으로 제공한 경우, 이용자의 고의나 중대한 과실로 인하여 제3자가 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있었던 경우에는 대부업자가 책임을 지지 않습니다.</li>
        </ul>
      `
    }
  };
  
  if (agreements[num]) {
    title.textContent = agreements[num].title;
    content.innerHTML = agreements[num].content;
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden'; // 스크롤 방지
    // 스크롤 위치를 맨 위로 리셋
    content.scrollTop = 0;
    modal.scrollTop = 0;
  }
}

// 모달 닫기
function closeAgreementModal() {
  const modal = document.getElementById('agreementModal');
  modal.style.display = 'none';
  document.body.style.overflow = ''; // 스크롤 복원
}

// 모든 필수 동의 확인
function checkAllAgreements() {
  // 필수 동의 체크 (so_c2030.html: agree10, agree20, agree30, agree40)
  const requiredAgreements = ['agree10', 'agree20', 'agree30', 'agree40'];
  // 기존 라디오 에러 표시 제거
  document.querySelectorAll('input.radio-error').forEach(r => r.classList.remove('radio-error'));

  let firstMissing = null;
  for (let name of requiredAgreements) {
    const checked = document.querySelector(`input[name="${name}"]:checked`);
    if (!checked || checked.value !== 'Y') {
      const yesInput = document.querySelector(`input[name="${name}"][value="Y"]`);
      if (yesInput) {
        yesInput.classList.add('radio-error');
        if (!firstMissing) firstMissing = yesInput;
      }
    }
  }
  if (firstMissing) {
    const container = firstMissing.closest('.agreement-item') || firstMissing;
    container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    alert('필수 항목을 모두 동의해주세요');
    return false;
  }
  
  // 선택 동의 체크 (so_c2030.html: agree50, agree80)
  const optionalAgreements = ['agree50', 'agree80'];
  let firstOptionalMissing = null;
  for (let name of optionalAgreements) {
    const checked = document.querySelector(`input[name="${name}"]:checked`);
    if (!checked) {
      const yesInput = document.querySelector(`input[name="${name}"][value="Y"]`);
      if (yesInput) {
        yesInput.classList.add('radio-error');
        if (!firstOptionalMissing) firstOptionalMissing = yesInput;
      }
    }
  }
  if (firstOptionalMissing) {
    const container = firstOptionalMissing.closest('.agreement-item') || firstOptionalMissing;
    container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    alert('선택 항목을 선택해주세요 (동의 또는 비동의)');
    return false;
  }
  
  return true;
}

// 대출 신청 제출
function submitLoanApplication() {
  // 동의 사항 확인
  if (!checkAllAgreements()) {
    return false;
  }
  
  const stockAccount = document.getElementsByName('stockAccount')[0].value;
  const loanAmount = document.getElementsByName('loanAmount')[0].value;
  const phone2 = document.getElementsByName('phone2')[0].value;
  const phone3 = document.getElementsByName('phone3')[0].value;
  const email1 = document.getElementsByName('email1')[0].value;
  const email2 = document.getElementsByName('email2')[0].value;
  
  if (!stockAccount || !loanAmount || !phone2 || !phone3 || !email1 || !email2) {
    alert('모든 필수 항목을 확인해주세요.');
    return false;
  }
  
  alert('대출가능금액 조회가 완료되었습니다. 다음 단계(대출신청) 페이지로 이동합니다.');
  window.location.href = 'ST02030R_1.html';
  return false;
}

// 두 번째 휴대전화 인증
function verifyPhone2() {
  const phone1 = document.getElementsByName('phone1_2')[0].value;
  const phone2 = document.getElementsByName('phone2_2')[0].value;
  const phone3 = document.getElementsByName('phone3_2')[0].value;
  const telecom = document.querySelector('input[name="telecom2"]:checked');
  
  if (!phone1 || !phone2 || !phone3) {
    alert('휴대전화번호를 모두 입력해주세요.');
    return;
  }
  
  if (!telecom) {
    alert('통신사를 선택해주세요.');
    return;
  }
  
  alert('휴대전화 인증이 완료되었습니다.');
}

// 최종 신청 제출
function submitFinalApplication() {
  // 제출 전 필수 동의 재검증
  if (!checkAllAgreements()) {
    return false;
  }
  const ssn1 = document.getElementsByName('ssn1')[0].value;
  const ssn2 = document.getElementsByName('ssn2')[0].value;
  const customerName = document.getElementsByName('customerName')[0].value;
  const stockAccount2 = document.getElementsByName('stockAccount2')[0].value;
  const loanAmount2 = document.getElementsByName('loanAmount2')[0].value;
  
  if (!ssn1 || !ssn2) {
    alert('주민등록번호를 입력해주세요.');
    return false;
  }
  
  if (!customerName) {
    alert('성명을 입력해주세요.');
    return false;
  }
  
  if (!stockAccount2) {
    alert('증권계좌번호를 입력해주세요.');
    return false;
  }
  
  if (!loanAmount2) {
    alert('대출신청금액을 입력해주세요.');
    return false;
  }
  
  alert('대출신청이 완료되었습니다. 심사 결과는 영업일 기준 1-2일 내에 연락드리겠습니다.');
  return false; // 실제 제출 방지 (데모용)
}

// 전체 필수 동의 동기화
function syncAllRequired(value) {
  const targets = ['agree10', 'agree20', 'agree30', 'agree40']; // so_c2030.html 필수 항목만
  targets.forEach(name => {
    const yes = document.querySelector('input[name="' + name + '"][value="Y"]');
    const no = document.querySelector('input[name="' + name + '"][value="N"]');
    if (yes && no) {
      if (value === 'Y') yes.checked = true; else if (value === 'N') no.checked = true;
    }
  });
}

// 필수 동의 'Y' 개수 카운트
function countRequiredYes() {
  const names = ['agree10', 'agree20', 'agree30', 'agree40']; // so_c2030.html 필수 항목만
  let count = 0;
  names.forEach(name => {
    const checked = document.querySelector('input[name="' + name + '"]:checked');
    if (checked && checked.value === 'Y') count++;
  });
  return count;
}

// 전체 필수 동의 체크박스 업데이트
function updateAllRequiredCheckbox() {
  const allCb = document.getElementById('allRequiredCheck');
  if (allCb) {
    allCb.checked = (countRequiredYes() === 4); // so_c2030.html은 필수 4개
  }
}

// 선택 항목 확인 (비동의는 허용하지만, 미선택은 허용하지 않음)
function checkOptionalSelections() {
  const optionalNames = ['agree50', 'agree80']; // so_c2030.html 선택 항목
  for (let name of optionalNames) {
    const checked = document.querySelector('input[name="' + name + '"]:checked');
    if (!checked) {
      const any = document.querySelector('input[name="' + name + '"]');
      const container = any ? (any.closest('.agreement-item') || any.closest('.agreement-section') || any) : null;
      if (container) {
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      alert('선택 동의 항목을 확인해주세요');
      return false;
    }
  }
  return true;
}

// 선택 항목 전체동의 동기화 (비필수이므로 검증에는 영향 없음)
function syncAllOptional(value) {
  const targets = ['agree50', 'agree80']; // so_c2030.html 선택 항목
  targets.forEach(name => {
    const yes = document.querySelector('input[name="' + name + '"][value="Y"]');
    if (yes && value === 'Y') {
      yes.checked = true;
    }
  });
}

// 전체 선택 항목 초기화 (모두 미선택)
function clearAllOptional() {
  const names = ['agree50', 'agree80']; // so_c2030.html 선택 항목
  names.forEach(name => {
    document.querySelectorAll('input[name="' + name + '"]').forEach(inp => {
      inp.checked = false; // 라디오 Y/N 모두 해제 => 미선택 상태
    });
  });
}

// 전체 필수 동의 초기화 (모두 미선택)
function clearAllRequired() {
  const names = ['agree10', 'agree20', 'agree30', 'agree40']; // so_c2030.html 필수 항목
  names.forEach(name => {
    document.querySelectorAll('input[name="' + name + '"]').forEach(inp => {
      inp.checked = false; // 라디오 Y/N 모두 해제 => 미선택 상태
    });
  });
}

// 다음 단계로 이동
function goNextStep() {
  // 필수 동의 점검: 미선택/비동의 있으면 강조 + 경고 후 중단
  if (!checkAllAgreements()) {
    return;
  }
  // 선택 동의 점검: 각 항목은 반드시 선택 필요(동의/비동의 모두 허용), 미선택 시 안내
  if (!checkOptionalSelections()) {
    return;
  }
  // 모두 동의 시 다음 페이지로 이동
  window.location.href = 'so_c2032.html';
}

// DOM 로드 완료 후 이벤트 핸들러 등록
document.addEventListener('DOMContentLoaded', () => {
  const allCb = document.getElementById('allRequiredCheck');
  if (allCb) {
    allCb.addEventListener('change', e => {
      if (e.target.checked) {
        // 체크 시 전체 동의로 설정
        syncAllRequired('Y');
      } else {
        // 체크 해제 시 모두 미선택으로 초기화
        clearAllRequired();
      }
      updateAllRequiredCheckbox();
    });
  }

  const allOptionalCb = document.getElementById('allOptionalCheck');
  if (allOptionalCb) {
    allOptionalCb.addEventListener('change', e => {
      if (e.target.checked) {
        syncAllOptional('Y');
      } else {
        // 체크 해제 시 모두 미선택으로 초기화
        clearAllOptional();
      }
    });
  }

  // 개별 변경 시 진행률 갱신 및 체크박스 상태 동기화
  const requiredNames = ['agree10', 'agree20', 'agree30', 'agree40']; // so_c2030.html 필수 항목
  const optionalNames = ['agree50', 'agree80']; // so_c2030.html 선택 항목
  
  // 필수 항목 이벤트
  requiredNames.forEach(name => {
    document.querySelectorAll('input[name="' + name + '"]').forEach(inp => {
      inp.addEventListener('change', () => {
        document.querySelectorAll('input[name="' + name + '"]').forEach(radio => {
          radio.classList.remove('radio-error');
        });
        updateAllRequiredCheckbox();
      });
    });
  });
  
  // 선택 항목 이벤트 (필수 체크박스와 연동하지 않음)
  optionalNames.forEach(name => {
    document.querySelectorAll('input[name="' + name + '"]').forEach(inp => {
      inp.addEventListener('change', () => {
        document.querySelectorAll('input[name="' + name + '"]').forEach(radio => {
          radio.classList.remove('radio-error');
        });
      });
    });
  });
  
  updateAllRequiredCheckbox();
});

// 모달 외부 클릭 시 닫기
window.addEventListener('click', function(event) {
  const modal = document.getElementById('agreementModal');
  if (event.target === modal) {
    closeAgreementModal();
  }
});

// 전역 함수 노출 (Vue에서 사용 가능)
window.showAgreement = showAgreement;
window.closeAgreementModal = closeAgreementModal;
window.checkAllAgreements = checkAllAgreements;
window.setEmailDomain = setEmailDomain;
window.verifyPhone = verifyPhone;
window.submitLoanApplication = submitLoanApplication;
window.submitFinalApplication = submitFinalApplication;
window.syncAllRequired = syncAllRequired;
window.syncAllOptional = syncAllOptional;
window.clearAllRequired = clearAllRequired;
window.clearAllOptional = clearAllOptional;
window.updateAllRequiredCheckbox = updateAllRequiredCheckbox;
window.checkOptionalSelections = checkOptionalSelections;
window.goNextStep = goNextStep;

/**
 * ========================================
 * 회원가입 페이지용 약관 모달 함수
 * ========================================
 */

// 회원가입 페이지용 약관 열기 (auth-signup.html)
function openModal(type) {
  const modal = document.getElementById('agreementModal');
  const title = document.getElementById('agreementTitle');
  const content = document.getElementById('agreementContent');
  
  if (!modal || !title || !content) {
    return;
  }

  const modalData = {
    terms: {
      title: '서비스 이용약관',
      content: `
        <h3 style="color: #1976d2; margin-top: 28px; margin-bottom: 16px; font-size: 1.2em;">제1장 총칙</h3>
        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제1조 (목적)</h4>
        <p style="margin-bottom: 12px; line-height: 1.6;">이 약관은 빌리언대부 주식회사(이하 "회사"라 함)이 제공하는 주식담보대출 서비스(이하 "서비스"라 함)의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
        
        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제2조 (정의)</h4>
        <p style="margin-bottom: 12px; line-height: 1.6;">이 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 6px;">"서비스"란 회사가 제공하는 주식담보대출 관련 제반 서비스를 의미합니다.</li>
          <li style="margin-bottom: 6px;">"회원"이란 회사와 서비스 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
          <li style="margin-bottom: 6px;">"아이디(ID)"란 회원의 식별과 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.</li>
        </ol>

        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제3조 (약관의 효력 및 변경)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">이 약관은 서비스를 이용하고자 하는 모든 회원에 대하여 그 효력을 발생합니다.</li>
          <li style="margin-bottom: 8px;">회사가 이 약관을 변경하고자 할 경우, 회원에게 불리한 내용이 될 때에는 서면통지 또는 이메일의 방법으로 이를 알리고, 회원에게 불리한 내용이 아닌 경우에는 웹사이트에 게시함으로써 이를 알립니다.</li>
          <li style="margin-bottom: 8px;">통지 또는 게시한 날로부터 1개월 이내에 회원의 서면 또는 이메일에 의한 이의가 회사에 도달하지 않은 때에는 약관의 변경을 승인한 것으로 봅니다.</li>
        </ol>

        <h3 style="color: #1976d2; margin-top: 28px; margin-bottom: 16px; font-size: 1.2em;">제2장 회원가입 및 관리</h3>
        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제4조 (서비스의 제공 및 변경)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">회사는 다음과 같은 업무를 수행합니다:
            <ul style="margin-left: 20px; margin-top: 6px; line-height: 1.6;">
              <li style="margin-bottom: 4px;">주식담보대출 서비스 제공</li>
              <li style="margin-bottom: 4px;">대출 상담 및 안내 서비스</li>
              <li style="margin-bottom: 4px;">기타 회사가 정하는 업무</li>
            </ul>
          </li>
          <li style="margin-bottom: 8px;">회사는 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.</li>
        </ol>
        
        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제5조 (회원가입)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</li>
          <li style="margin-bottom: 8px;">회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다:
            <ul style="margin-left: 20px; margin-top: 6px; line-height: 1.6;">
              <li style="margin-bottom: 4px;">가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
              <li style="margin-bottom: 4px;">등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
              <li style="margin-bottom: 4px;">기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
            </ul>
          </li>
          <li style="margin-bottom: 8px;">회원가입계약의 성립시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.</li>
        </ol>

        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제6조 (회원정보의 변경)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.</li>
          <li style="margin-bottom: 8px;">회원은 회원가입시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 회사에 그 변경사항을 알려야 합니다.</li>
          <li style="margin-bottom: 8px;">제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여는 회원에게 책임이 있습니다.</li>
        </ol>

        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제7조 (회원에 대한 통지)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">회사가 회원에 대한 통지를 하는 경우 회원이 회사에 제출한 전자우편 주소로 할 수 있습니다.</li>
          <li style="margin-bottom: 8px;">회사는 불특정다수 회원에 대한 통지의 경우 1주일 이상 회사 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.</li>
          <li style="margin-bottom: 8px;">회원이 제6조 제2항에 의한 통지를 게을리하여 발송한 통지가 도달하지 않거나 연착한 때에는 통상의 우송기간이 경과한 때에 도달한 것으로 봅니다.</li>
        </ol>

        <h3 style="color: #1976d2; margin-top: 28px; margin-bottom: 16px; font-size: 1.2em;">제3장 계약당사자의 의무</h3>
        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제8조 (회사의 의무)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는데 최선을 다하여야 합니다.</li>
          <li style="margin-bottom: 8px;">회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.</li>
          <li style="margin-bottom: 8px;">회사는 서비스 이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.</li>
        </ol>

        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제9조 (회원의 의무)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">회원은 다음 행위를 하여서는 안 됩니다:
            <ul style="margin-left: 20px; margin-top: 6px; line-height: 1.6;">
              <li style="margin-bottom: 4px;">신청 또는 변경시 허위 내용의 등록</li>
              <li style="margin-bottom: 4px;">타인의 정보 도용</li>
              <li style="margin-bottom: 4px;">회사가 게시한 정보의 변경</li>
              <li style="margin-bottom: 4px;">회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
              <li style="margin-bottom: 4px;">회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
              <li style="margin-bottom: 4px;">회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
              <li style="margin-bottom: 4px;">외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위</li>
            </ul>
          </li>
          <li style="margin-bottom: 8px;">회원은 관계 법령, 이 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.</li>
        </ol>

        <h3 style="color: #1976d2; margin-top: 28px; margin-bottom: 16px; font-size: 1.2em;">제4장 서비스 이용</h3>
        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제10조 (서비스 이용 시간)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">서비스 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 운영을 원칙으로 합니다.</li>
          <li style="margin-bottom: 8px;">회사는 시스템 정기점검, 증설 및 교체를 위해 회사가 정한 날이나 시간에 서비스를 일시 중단할 수 있으며, 예정되어 있는 작업으로 인한 서비스 일시 중단은 웹사이트를 통해 사전에 공지합니다.</li>
        </ol>

        <h4 style="color: #333; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제11조 (서비스 이용 제한)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;">회사는 회원이 제9조의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</li>
          <li style="margin-bottom: 8px;">회사는 전항에도 불구하고, 주민등록법을 위반한 명의도용 및 결제도용, 전화번호 도용, 저작권법 및 컴퓨터프로그램보호법을 위반한 불법프로그램의 제공 및 운영방해, 정보통신망법을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다.</li>
        </ol>
      `
    },
    privacy: {
      title: '개인정보처리방침',
      content: `
        <p class="modal-notice" style="background-color: #f8f9fa; padding: 16px; border-left: 4px solid #0066cc; margin-bottom: 20px; border-radius: 4px; line-height: 1.6;">
          빌리언대부 주식회사(이하 '회사')은 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
        </p>
        
        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제1조 (개인정보의 처리목적)</h4>
        <p style="margin-bottom: 12px; line-height: 1.6;">회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;"><strong>회원 가입 및 관리</strong><br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지</li>
          <li style="margin-bottom: 8px;"><strong>대출 서비스 제공</strong><br>대출 상담, 대출 심사, 대출 계약 체결 및 이행, 대출금 지급 및 회수, 계약서·청구서 발송, 콘텐츠 제공, 본인인증, 연령인증, 요금결제·정산</li>
          <li style="margin-bottom: 8px;"><strong>본인 확인 및 신용 평가</strong><br>신용정보 조회, 본인확인, 대출 한도 산정</li>
          <li style="margin-bottom: 8px;"><strong>마케팅 및 광고에 활용</strong><br>신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악, 회원의 서비스 이용에 대한 통계</li>
          <li style="margin-bottom: 8px;"><strong>고충 처리</strong><br>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보</li>
        </ol>

        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제2조 (처리하는 개인정보의 항목)</h4>
        <p style="margin-bottom: 12px; line-height: 1.6;">회사는 다음의 개인정보 항목을 처리하고 있습니다:</p>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 8px;"><strong>회원가입 및 관리</strong><br>성명, 생년월일, 아이디, 비밀번호, 주소, 전화번호, 이메일</li>
          <li style="margin-bottom: 8px;"><strong>대출서비스 제공</strong><br>성명, 주민등록번호, 주소, 전화번호, 직장정보, 소득정보, 신용정보, 계좌정보</li>
          <li style="margin-bottom: 8px;"><strong>인터넷 서비스 이용과정에서 자동 수집되는 정보</strong><br>IP주소, 쿠키, 서비스 이용기록, 방문기록, 불량 이용기록 등</li>
          <li style="margin-bottom: 12px;">
            <strong>서비스 제공을 위한 필요 최소한의 개인정보를 수집합니다.</strong><br>
            회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별 어플리케이션이나 프로그램 등을 통해 서비스 제공을 위해 필요 최소한의 개인정보를 수집하고 있습니다.
            <div style="margin-top: 12px; margin-left: 20px;">
              <p style="margin-bottom: 8px; font-weight: bold; color: #1976d2;">[카카오계정 가입 시]</p>
              <ul style="margin-left: 20px; margin-bottom: 12px; line-height: 1.6;">
                <li style="margin-bottom: 6px;"><strong>필수:</strong> 이메일, 비밀번호, 이름(닉네임), 프로필사진, 친구목록, 카카오톡 전화번호(카카오톡 이용자의 경우에 한함), 연락처, 서비스 이용내역, 서비스 내 구매 및 결제 내역</li>
                <li style="margin-bottom: 6px;"><strong>선택:</strong> 생년월일, 성별, 배송지정보(수령인명, 배송지주소, 전화번호)</li>
              </ul>
              
              <p style="margin-bottom: 8px; font-weight: bold; color: #1976d2;">[사업자/단체 카카오계정 가입 시]</p>
              <ul style="margin-left: 20px; margin-bottom: 12px; line-height: 1.6;">
                <li style="margin-bottom: 6px;"><strong>필수:</strong> 이메일, 비밀번호, 사업자/단체명, 프로필사진, 친구목록, 연락처, 서비스 이용내역, 서비스 내 구매 및 결제 내역, 담당자 본인 인증정보(이름, 생년월일, 성별, 아이디, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI), 내/외국인 여부), 담당자 연락처(이메일 주소, 휴대전화번호)</li>
              </ul>
              
              <p style="margin-top: 16px; margin-bottom: 12px; line-height: 1.6; padding: 12px; background-color: #f8f9fa; border-radius: 4px;">
                일부 서비스에서는 특화된 여러 기능을 제공하기 위해 이용자에게 동의를 받고 추가적인 개인정보를 수집할 수 있습니다.
              </p>
              
              <ul style="margin-left: 20px; margin-bottom: 12px; line-height: 1.6;">
                <li style="margin-bottom: 4px;"><strong>필수정보란?</strong> 해당 서비스의 본질적 기능을 수행하기 위한 정보</li>
                <li style="margin-bottom: 4px;"><strong>선택정보란?</strong> 보다 특화된 서비스를 제공하기 위해 추가 수집하는 정보 (선택 정보를 입력하지 않은 경우에도 서비스 이용 제한은 없습니다.)</li>
              </ul>
              
              <p style="margin-top: 16px; margin-bottom: 8px; font-weight: bold;">서비스에서 별도로 수집하는 개인정보 항목</p>
              
              <p style="margin-bottom: 8px; font-weight: bold; color: #1976d2;">[본인인증 시]</p>
              <p style="margin-left: 20px; margin-bottom: 12px; line-height: 1.6;">
                이름, 성별, 생년월일, 휴대전화번호, 통신사업자, 내/외국인 여부, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)
              </p>
              
              <p style="margin-bottom: 8px; font-weight: bold; color: #1976d2;">[법정대리인 동의 시]</p>
              <p style="margin-left: 20px; margin-bottom: 12px; line-height: 1.6;">
                법정대리인 정보(이름, 성별, 생년월일, 휴대전화번호, 통신사업자, 내/외국인 여부, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI))
              </p>
            </div>
          </li>
        </ol>

        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제3조 (개인정보의 처리 및 보유기간)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 12px;">회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</li>
          <li style="margin-bottom: 12px;">각각의 개인정보 처리 및 보유 기간은 다음과 같습니다:
            <ol style="margin-left: 20px; margin-top: 8px; list-style-type: lower-alpha;">
              <li style="margin-bottom: 8px;"><strong>회원 가입 및 관리:</strong> 회원 탈퇴시까지<br>
                (다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지)
                <ol style="margin-left: 20px; margin-top: 6px; list-style-type: circle;">
                  <li style="margin-bottom: 4px;">관련 법령 위반에 따른 수사·조사 등이 진행중인 경우에는 해당 수사·조사 종료시까지</li>
                  <li style="margin-bottom: 4px;">웹사이트 이용에 따른 채권·채무관계 잔존시에는 해당 채권·채무관계 정산시까지</li>
                </ol>
              </li>
              <li style="margin-bottom: 8px;"><strong>재화 또는 서비스 제공:</strong> 재화·서비스 공급완료 및 요금결제·정산 완료시까지<br>
                (다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료시까지)
                <ol style="margin-left: 20px; margin-top: 6px; list-style-type: circle;">
                  <li style="margin-bottom: 4px;">「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시·광고, 계약내용 및 이행 등에 관한 기록: 5년</li>
                  <li style="margin-bottom: 4px;">「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
                  <li style="margin-bottom: 4px;">「신용정보의 이용 및 보호에 관한 법률」에 따른 신용정보의 수집·처리 및 이용 등에 관한 기록: 3년</li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>

        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제4조 (개인정보의 제3자 제공)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 12px;">회사는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</li>
          <li style="margin-bottom: 12px;">회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다:
            <ol style="margin-left: 20px; margin-top: 8px; list-style-type: lower-alpha;">
              <li style="margin-bottom: 6px;"><strong>신용평가회사:</strong> 신용조회 목적으로 최소한의 정보만 제공</li>
              <li style="margin-bottom: 6px;"><strong>금융감독원:</strong> 법령에 의한 금융감독 목적</li>
              <li style="margin-bottom: 6px;"><strong>국세청:</strong> 세법에 의한 자료제출 의무</li>
            </ol>
          </li>
        </ol>

        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제5조 (개인정보처리의 위탁)</h4>
        <p style="margin-bottom: 12px; line-height: 1.6;">회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다:</p>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 6px;"><strong>위탁받는 자:</strong> 본인인증 서비스 제공업체</li>
          <li style="margin-bottom: 6px;"><strong>위탁하는 업무의 내용:</strong> 본인인증 및 본인확인</li>
        </ol>

        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제6조 (정보주체의 권리·의무 및 행사방법)</h4>
        <p style="margin-bottom: 12px; line-height: 1.6;">정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다:</p>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 6px;">개인정보 열람요구</li>
          <li style="margin-bottom: 6px;">오류 등이 있을 경우 정정 요구</li>
          <li style="margin-bottom: 6px;">삭제요구</li>
          <li style="margin-bottom: 6px;">처리정지 요구</li>
        </ol>

        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제7조 (개인정보의 파기)</h4>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 12px;">회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</li>
          <li style="margin-bottom: 12px;">정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</li>
          <li style="margin-bottom: 12px;">개인정보 파기의 절차 및 방법은 다음과 같습니다:
            <ol style="margin-left: 20px; margin-top: 8px; list-style-type: lower-alpha;">
              <li style="margin-bottom: 6px;"><strong>파기절차:</strong> 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</li>
              <li style="margin-bottom: 6px;"><strong>파기방법:</strong> 회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</li>
            </ol>
          </li>
        </ol>

        <h4 style="color: #1976d2; margin-top: 24px; margin-bottom: 12px; font-size: 1.1em;">제8조 (개인정보 보호책임자)</h4>
        <p style="margin-bottom: 12px; line-height: 1.6;">회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
        <ol style="margin-left: 20px; margin-bottom: 16px; line-height: 1.8;">
          <li style="margin-bottom: 6px;">성명: 차승현</li>
          <li style="margin-bottom: 6px;">직책: 개인정보관리책임자</li>
          <li style="margin-bottom: 6px;">연락처: 1833-8996, billion_so@zebragroup.co.kr</li>
        </ol>
        
        <p style="margin-top: 24px; padding-top: 16px; border-top: 1px solid #e0e0e0; text-align: center; font-weight: bold; color: #1976d2;">본 방침은 2026년 1월 1일부터 시행됩니다.</p>
      `
    }
  };

  if (modalData[type]) {
    title.textContent = modalData[type].title;
    content.innerHTML = modalData[type].content;
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    content.scrollTop = 0;
    modal.scrollTop = 0;
  }
}

// 회원가입 페이지용 모달 닫기 (closeAgreementModal과 동일하게 동작)
function closeModal(type) {
  closeAgreementModal();
}

// 회원가입용 모달 함수도 전역 노출
window.openModal = openModal;
window.closeModal = closeModal;
